import { DISCOUNT_METHODS } from "../../helpers/constants";

export default {
  computed: {
    hasDiscount() {
      const discountMethods = Object.values(DISCOUNT_METHODS);

      if (discountMethods.includes(this.trip.discount_method)) {
        if (this.trip.discount_method === "percentage") {
          return Boolean(this.trip.discount);
        }

        return true;
      }

      return false;
    },
    highlightType() {
      if (this.hasDiscount) {
        return "discount";
      } else {
        switch (this.trip.itineraries.highlight_type) {
          case "Marine life":
            return "blue";
          case "Conservation":
            return "green";
          case "Expert Led":
            return "marine";
          default:
            return "blue";
        }
      }
    },
    tripDate() {
      return moment(this.trip.departure_date).format("D");
    },
    tripMonth() {
      return moment(this.trip.departure_date).format("MMM");
    },
    tripYear() {
      return moment(this.trip.departure_date).format("YYYY");
    },
    lowestPrice() {
      return this.trip.prices.find((price) => price.lowest_price);
    },
    isSoldOut() {
      const isSoldOut = this.trip.available === "Sold out";
      const today = moment();
      const mmTripDate = moment(this.trip.departure_date, "YYYY-MM-DD");
      const isInThePast = mmTripDate.isBefore(today, "day");

      return isSoldOut || isInThePast;
    },
    cabinAvailabilityV2() {},
    cabinAvailability() {
      switch (this.trip.available) {
        case "Full":
          return {
            text: "Full",
            class: "availability-full",
          };
        case "Limited availability":
          return {
            text: "Limited availability",
            class: "availability-limited",
          };
        case "Available for charter":
          return {
            text: "Available for charter",
            class: "availability-available-charter",
          };
        case "Available":
          return {
            text: "Available",
            class: "availability-available",
          };
        case "Sold out":
          return {
            text: "Sold out",
            class: "availability-soldout",
          };
        case "On request":
          return {
            text: "On request",
            class: "availability-on-request",
          };
        case "4 spaces":
          return {
            text: "4 spaces left",
            class: "availability-limited",
          };
        case "3 spaces":
          return {
            text: "3 spaces left",
            class: "availability-limited",
          };
        case "2S spaces":
        case "2 spaces":
          return {
            text: "2 spaces left",
            class: "availability-limited",
          };
        case "1 space":
          return {
            text: "1 space left",
            class: "availability-limited",
          };
        case "1F space":
          return {
            text: "1 female space left",
            class: "availability-limited",
          };
        case "1M space":
          return {
            text: "1 male space left",
            class: "availability-limited",
          };
        default:
          return {
            text: this.trip.available,
            class: "",
          };
      }
    },
  },
};
